import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mt-s3" }

import Notice from '@/components/Notice.vue';
import TokenCollapseGroup from '@/components/token/TokenCollapseGroup.vue';
import { TokenInfo } from '@/sdk/entities/portfolio';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectTokensNotice',
  props: {
    tokensToSelect: null
  },
  emits: ["selectToken"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'selectToken', value: TokenInfo): void;
}), expose: any, slots: any, attrs: any }) {

const { t } = useI18n();





const translation = t('portfolio.easyModeTranslations.common.notices.selectTokens');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Notice, { icon: "check" }, {
    "notice-text": _withCtx(() => [
      _createElementVNode("div", null, _toDisplayString(_unref(translation)), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(TokenCollapseGroup, {
          tokens: __props.tokensToSelect,
          onClick: _cache[0] || (_cache[0] = value => emit('selectToken', value))
        }, null, 8, ["tokens"])
      ])
    ]),
    _: 1
  }))
}
}

})